import React, { Component, useState, useEffect, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import "swiper/css/navigation";
import "swiper/css/bundle";
import Hover from "../OnHoverDetails/Hover";
var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export function Layout7(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  return (
    <>
      {window.innerWidth > 768 ?
        <>
          <section className="mb-0 dD-block">
            <div className="temp14">
              {/* {showShimmer ? (
                <div className="linedesk" />
              ) : ( */}
              <>
                <div className="head-layout">
                  <h3>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h3>
                  <div className="arrow-layout">
                    {props.title.show_more ? (
                      <Link to={"/baypage/" + props.title.slug}>
                        <div className="hoverText">View All</div>
                      </Link>
                    ) : null}
                    <div className="arrow-icon">
                      {props.title.show_more ? (
                        <Link to={"/baypage/" + props.title.slug}>
                          <img src={SVGIcon["right-arrow.svg"]} />
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
              {/* )} */}
              <div className="temp14-area">
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  slidesPerView={2.4}
                  spaceBetween={16}
                  slidesPerGroup={5}
                  freeMode={true}
                  loop={false}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  modules={[Navigation, FreeMode, Pagination]}
                  className="temp14-slider"
                >
                  <div className="side-overlay-L dD-block"></div>
                  <button
                    className="slick-prev slick-arrow"
                    type="button"
                    aria-label="Previous"
                  />
                  {props.Layout1.map((data, index) => {
                    // var GenereTitle = data.genres.split(",");
                    // GenereTitle = GenereTitle[0];
                    var keywords = data.keywords.split(",");
                    var premium = "";
                    if (data.premium && !data.original_tag) {
                      var premium = (
                        <img
                          src={props.silverIcon}
                          style={{
                            width: "1.7rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    if (data.original_tag && data.premium) {
                      var original = (
                        <img
                          src={props.goldenIcon}
                          style={{
                            width: "1.7rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    return (
                      <SwiperSlide key={index} className="temp14-item">
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <Hover
                            data={data}
                            silverIcon={props.silverIcon}
                            goldenIcon={props.goldenIcon}
                          />
                          <div className="temp14-itemColor">
                            <img src={data.vertical_banner.small} alt="DocuBay" />
                          </div>
                          <div className="bay-title">{keywords[0]}</div>
                          <div className="premium-red">
                            {premium}
                            {original}
                          </div>
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide></SwiperSlide>
                  <div className="side-overlay-R dD-block"></div>
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </section>
        </>
        :
        <>
          <section className="mb-0 dD-none">
            <div className="temp14">
              {/* {showShimmer ? (
                <div className="line linehead" />
              ) : ( */}
              <>
                <div className="head">
                  <h3>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h3>
                  {props.title.show_more ? (
                    <Link to={"/baypage/" + props.title.slug}>
                      {" "}
                      <img src={SVGIcon["right-arrow.svg"]} />{" "}
                    </Link>
                  ) : null}
                </div>
              </>
              {/* )} */}
              <div className="temp14-area">
                <Swiper
                  slidesPerView={2.4}
                  spaceBetween={16}
                  freeMode={true}
                  loop={false}
                  loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    700: {
                      slidesPerView: 4.2,
                    },
                    810: {
                      slidesPerView: 4.4,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  modules={[FreeMode, Pagination]}
                  className="temp14-slider"
                >
                  {props.Layout1.map((data, index) => {
                    // var GenereTitle = data.genres.split(",");
                    // GenereTitle = GenereTitle[0];
                    var premium = "";
                    var keywords = data.keywords.split(",");
                    if (data.premium && !data.original_tag) {
                      var premium = (
                        <img
                          src={props.silverIcon}
                          style={{
                            width: "1.3rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    if (data.original_tag && data.premium) {
                      var original = (
                        <img
                          src={props.goldenIcon}
                          style={{
                            width: "1.3rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    return (
                      <SwiperSlide key={index} className="temp14-item">
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <div
                            onClick={() => {
                              showdetailspop(data);
                            }}
                          >
                            <div className="temp14-itemColor">
                              <img src={data.vertical_banner.small} alt="DocuBay" />
                            </div>
                            <div className="bay-title">{keywords[0]}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </div>
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide></SwiperSlide>
                </Swiper>
              </div>
            </div>
          </section>
        </>
      }


      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout7;
